import React from 'react'
import { Navigate } from 'react-router-dom'
import './template.css'
import Navbar from '../navbar'
import auth from '../../lib/auth'

type Props = {
    children: React.ReactNode
    auth?: boolean | string | Array<string>
}

export default function Template(props: Props) {
    // Enforce auth
    if (props.auth) {
        if (props.auth === true && !auth.isLoggedIn()) return <Navigate to='/login' />
        if (typeof props.auth === 'string' && !auth.checkRole(props.auth))
            return <Navigate to='/login' />
        if (props.auth instanceof Array && !auth.checkRole(...props.auth))
            return <Navigate to='/login' />
    }

    return (
        <div className='pb-5 bg-gray-100 min-h-screen'>
            <Navbar />
            {props.children}
        </div>
    )
}
